(() => {
  const roots = document.querySelectorAll('[data-chikas-wa]');
  if (!roots.length) return;

  roots.forEach((root) => {
    const panel = root.querySelector('[data-chikas-wa-panel]');
    const toggle = root.querySelector('[data-chikas-wa-toggle]');
    if (!panel || !toggle) return;

    const setOpen = (open) => {
      root.classList.toggle('is-open', open);
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Cerrar chat de WhatsApp' : 'Abrir chat de WhatsApp');
    };

    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      setOpen(panel.hidden);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !panel.hidden) setOpen(false);
    });

    document.addEventListener('click', (e) => {
      if (panel.hidden) return;
      if (root.contains(e.target)) return;
      setOpen(false);
    });
  });
})();
